import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-2" }

import { computed, Ref, ref, watch } from "vue";
import BigTitle from "@/components/Title/BigTitle.vue";
import ErrorText from "@/components/Texts/ErrorText.vue";
import PrimaryLabel from "@/components/Form/Common/PrimaryLabel.vue";
import InputNumber from "@/components/Form/Common/InputNumber.vue";
import PrimaryButton from "@/components/Form/Common/PrimaryButton.vue";
import { useGameStore } from "@/Store/useGameStore";
import EditPlayers from "@/components/Form/EditPlayers.vue";
import EditNumberDrinks from "@/components/Form/EditNumberDrinks.vue";
import { Form } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { z } from "zod";
import EditCategories from "@/components/Form/EditCategories.vue";

// Get all necessary reactive stuff from gameStore

export default /*#__PURE__*/_defineComponent({
  __name: 'GameMenu',
  setup(__props) {

const gameStore = useGameStore();

const numberRounds: Ref<number> = ref(gameStore.numberRounds);

watch(
  () => numberRounds.value,
  () => {
    gameStore.updateNumberRounds(numberRounds.value);
  },
  { deep: true }
);

const validationSchema = toTypedSchema(
  zod
    .object({
      minimumDrinks: z.number().min(1).max(15),
      maximumDrinks: zod.number().min(1).max(15),
      numberRounds: z.number().min(10).max(200),
    })
    .refine((data) => data.minimumDrinks < data.maximumDrinks, {
      message:
        "Le nombre de gorgées maximum doit être en dessous de celui minimum.",
      path: ["maximumDrinks"],
    })
  /*.refine((data) => gameStore.players.length >= 2, {
      message: "Le nombre de joueurs doit être au minimum de 2.",
      path: ["player-name"],
    })
    .refine((data) => gameStore.selectedCategories.length >= 2, {
      message: "Le nombre de joueurs doit être au minimum de 2.",
      path: ["categories"],
    })*/
);

const errorPlayers = computed(() => {
  return gameStore.errors.find((error) => error.path.includes("players"));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Form), {
    "validation-schema": _unref(validationSchema),
    onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_unref(gameStore).startGame()))
  }, {
    default: _withCtx(() => [
      _createVNode(BigTitle, {
        title: "Création de la partie",
        class: "text-center"
      }),
      _createVNode(EditPlayers),
      (errorPlayers.value)
        ? (_openBlock(), _createBlock(ErrorText, {
            key: 0,
            text: errorPlayers.value.message,
            class: "mt-2 text-left"
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      _createVNode(EditCategories),
      _createVNode(EditNumberDrinks),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(PrimaryLabel, {
          text: "Nombre de tours",
          class: "mb-2 text-left"
        }),
        _createVNode(InputNumber, {
          id: "numberRounds",
          name: "numberRounds",
          placeholder: "25",
          is_required: true,
          modelValue: numberRounds.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((numberRounds).value = $event)),
          modelModifiers: { number: true }
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(PrimaryButton, { label: "Commencer la partie" })
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}
}

})